import {createPlanetTheme} from '@apps-common/ui-theme/Themes.js';
import {getStyleOverrides} from './style/overrides.js';

export const monospace = {fontFamily: "'Roboto Mono', monospace"};

export const mapBackground = '#191a1a';

const theme = createPlanetTheme({
  colorScheme: 'light',
  extendedConfig: {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 960,
        xl: 960,
      },
    },
    components: getStyleOverrides,
  },
});

export default theme;
